import React from "react";
import { Box } from "@mui/joy";
import {
  footerBrandCaption11ItalicSx,
  footerBrandCaption11Sx,
  footerBrandCaption12Sx,
  footerBrandCaptionSeparatorSx,
  footerBrandColumnSx,
  footerBrandMetaRowSx,
  footerBrandRowCenteredSx,
} from "../../styles/globalStyles";
import DarkTypography from "./DarkTypography";
import { AppConfigContext } from "../../contexts/app/appConfig";
import { zekayStaticBranding } from "../../config/staticFiles";

interface FooterBrandProps {
  showChromeNote?: boolean;
}

export default function FooterBrand({ showChromeNote }: FooterBrandProps) {
  const appConfig = React.useContext(AppConfigContext);
  const year = new Date().getFullYear();
  const karapazSrc = zekayStaticBranding.karapazWebp();
  const chromeSrc = zekayStaticBranding.chromeBlackWebp();

  return (
    <Box sx={footerBrandColumnSx}>
      <Box sx={footerBrandRowCenteredSx}>
        <DarkTypography colorVariant="muted" sx={footerBrandCaption12Sx}>
          Zekay by
        </DarkTypography>
        <img
          src={karapazSrc}
          alt="Karapaz"
          height={42}
          style={{ opacity: 1, filter: "invert(1) grayscale(1) brightness(1.08) contrast(1.05)" }}
        />
      </Box>
      <Box sx={footerBrandMetaRowSx}>
        {showChromeNote && (
          <>
            <DarkTypography colorVariant="muted" sx={footerBrandCaption11ItalicSx}>
              Optimisé pour Chrome
            </DarkTypography>
            <img
              src={chromeSrc}
              width="20"
              alt="Chrome"
              style={{ filter: "invert(1)", opacity: 0.85 }}
            />
          </>
        )}
        {showChromeNote && (appConfig?.version || year) && (
          <DarkTypography colorVariant="muted" sx={footerBrandCaptionSeparatorSx}>
            •
          </DarkTypography>
        )}
        {appConfig?.version && (
          <DarkTypography colorVariant="muted" sx={footerBrandCaption11Sx}>
            {appConfig.version}
          </DarkTypography>
        )}
        {appConfig?.version && (
          <DarkTypography colorVariant="muted" sx={footerBrandCaptionSeparatorSx}>
            •
          </DarkTypography>
        )}
        <DarkTypography colorVariant="muted" sx={footerBrandCaption11Sx}>
          {year}
        </DarkTypography>
      </Box>
    </Box>
  );
}
